import { render, staticRenderFns } from "./stale-item-alert.vue?vue&type=template&id=00635c0b&"
import script from "./stale-item-alert.vue?vue&type=script&lang=ts&"
export * from "./stale-item-alert.vue?vue&type=script&lang=ts&"
import style0 from "./stale-item-alert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports